import { Attributes, System, SystemQueries } from "ecsy";
import { RotationData } from "../DataComponents/RotationData";
import { TransformData } from "../DataComponents/TransformData";
import { FanTag } from "../TagComponents/FanTag";

const bladeColors = ["red", "green", "blue"];

export class FanRenderSystem extends System {
  static queries: SystemQueries = {
    fans: {
      components: [FanTag, TransformData, RotationData],
    },
  };

  mainCanvas: HTMLCanvasElement;
  canvasContext: CanvasRenderingContext2D;

  init(attributes?: Attributes): void {
    this.mainCanvas = attributes.mainCanvas;
    this.canvasContext = this.mainCanvas.getContext("2d");
  }

  execute(delta: number, time: number): void {
    this.queries.fans.results.forEach((entity) => {
      const transformData = entity.getComponent(TransformData);
      const rotationData = entity.getComponent(RotationData);

      this.canvasContext.save();
      this.canvasContext.translate(
        transformData.position.x,
        transformData.position.y
      );
      this.canvasContext.rotate(rotationData.rotation);
      this.canvasContext.scale(0.7, 0.7);

      // Draw main body.
      this.canvasContext.beginPath();
      this.canvasContext.strokeStyle = "black";
      this.canvasContext.arc(0, 0, 20, 0, Math.PI * 2);
      this.canvasContext.closePath();
      this.canvasContext.stroke();

      // Draw bearing.
      this.canvasContext.save();
      this.canvasContext.translate(20, 0);
      this.canvasContext.fillStyle = "black";
      this.canvasContext.beginPath();
      this.canvasContext.arc(0, 0, 5, -Math.PI / 2, Math.PI / 2);
      this.canvasContext.closePath();
      this.canvasContext.fill();

      // Draw blades.
      for (let i = 0; i < 3; i++) {
        const angle = (Math.PI * 2 * i) / 3;

        this.canvasContext.save();
        this.canvasContext.translate(0, 0);
        this.canvasContext.scale(1, Math.sin(time * 4 + angle));
        this.canvasContext.beginPath();
        this.canvasContext.strokeStyle = bladeColors[i];
        this.canvasContext.moveTo(0, 0);
        this.canvasContext.lineTo(0, 10);
        this.canvasContext.lineTo(5, 100);
        this.canvasContext.lineTo(10, 0);
        this.canvasContext.closePath();
        this.canvasContext.stroke();
        this.canvasContext.restore();
      }

      this.canvasContext.restore();

      this.canvasContext.restore();
    });
  }
}
